export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM'
export const UPDATE_STATE_OBJ = 'UPDATE_STATE_OBJ'
export const RESET_SEARCH_PARAM = 'RESET_SEARCH_PARAM'
export const UPDATE_NAMESPACE = 'UPDATE_NAMESPACE'
